export const MULTIPLY_OPTIONS = 'multipleOptions';
export const SIZES = 'sizes';
export const INCLUDE_INTERNATIONAL = 'includeInternational';
export const GROUP_BY_COUNTRY = 'groupByCountry';
export const COUNTRIES = 'countries';
